/* ARRAY - MY REWARDS, the referral link's Copy button.

   A SEPARATE FILE FROM beyondads-rewards-page.js on purpose. That file owns the
   points slider and the FAQ animation, both of which took several rounds to get
   right; this is a self-contained 40-line behaviour for a band that is still
   being designed. Keeping them apart means iterating on the referral cannot
   break the slider.

   DOCUMENT-LEVEL DELEGATION, not a per-button listener: inline scripts inside a
   section on this theme have bound to nothing before, and the band can be
   re-rendered by the theme editor at any time.

   IT REALLY COPIES. navigator.clipboard needs a secure context, which
   array-lb.com is, but it also rejects when the document is not focused or the
   user has denied clipboard access - so there is a selection fallback behind
   it. The input is readonly, and execCommand('copy') will not read a readonly
   field on iOS, which is why readonly is lifted for the length of the call and
   put straight back. Without that the button silently does nothing on iPhone,
   which is the worst outcome for a share control.

   29 Sep 2026 FIX: the v3 band ("Good things come back.") renamed the wrapper
   .rf-box -> .gg-box, so the lookup found no input and the button did nothing
   anywhere. The box lookup now accepts both, with the band as a last resort. */
(function () {
  'use strict';

  function flash(btn) {
    if (!btn.__label) btn.__label = btn.textContent;
    btn.textContent = btn.getAttribute('data-rf-done') || 'Copied';
    btn.classList.add('is-done');
    clearTimeout(btn.__t);
    btn.__t = setTimeout(function () {
      btn.textContent = btn.__label;
      btn.classList.remove('is-done');
    }, 1800);
  }

  function fallback(input, btn) {
    try {
      input.removeAttribute('readonly');
      input.select();
      input.setSelectionRange(0, 99999);
      var ok = document.execCommand('copy');
      input.setAttribute('readonly', '');
      input.blur();
      if (ok) flash(btn);
    } catch (e) {
      try { input.setAttribute('readonly', ''); } catch (e2) {}
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-rf-copy]');
    if (!btn) return;
    e.preventDefault();

    var box = btn.closest('.gg-box, .rf-box') || btn.closest('#rw-referral');
    var input = box && box.querySelector('[data-rf-link]');
    if (!input || !input.value) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(input.value).then(function () {
        flash(btn);
      }).catch(function () {
        fallback(input, btn);
      });
      return;
    }
    fallback(input, btn);
  });
})();
